import { Box } from '@mui/material';
import React from 'react';

import routes from '@/assets/constants/routes-no.ts';
import { Timer } from '@/ui/Timer.tsx';

import { UnderlinedText } from '../../../../../../components/UnderlinedText/index.ts';
import { ArrowLink } from '../../../../../_common/components/ArrowLink.tsx';
import { SUMMER_JULY_2024_COMPETITION_END_DATE } from '../../../config.ts';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

const dateFormatter = new Intl.DateTimeFormat('no', {
  day: 'numeric',
  month: 'long',
});
const dateStr = dateFormatter.format(SUMMER_JULY_2024_COMPETITION_END_DATE);

export type TimerSectionJulyProps = {
  // Empty
};

export const TimerSectionJuly: React.FC<TimerSectionJulyProps> = () => {
  return (
    <Section
      sx={{
        gap: '20px',
        flexDirection: { md: 'row' },
        flexWrap: { md: 'wrap', xl: 'initial' },
      }}
    >
      <Box
        sx={{
          textAlign: { xs: 'center', xl: 'left' },
          flex: { xl: 1.15 },
          width: { md: '100%', xl: 'auto' },
          mb: { md: 2 },
          pr: { xl: 8 },
          mt: { xl: 4 },
        }}
      >
        <div className="mb-6 typography-v1-h1">Vi forlenger kampanjen!</div>

        <p className="mx-auto mb-4 max-w-[70ch] typography-v1-body2">
          I juni trakk vi 10 heldige vinnere som fikk sende gjelden sin på ferie! På grunn av så
          stor interesse på å sende gjelden på ferie, har vi bestemt oss for å utvide kampanjen og
          trekke 5 vinnere til!
        </p>
        <p className="mx-auto mb-8 max-w-[70ch] typography-v1-body2">
          Meldte du deg på i juni er du automatisk med i denne trekningen også. Du trenger ikke å
          delta på nytt.
        </p>

        <CTA />
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.background.default,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Premie</p>
        <p className="typography-v1-display">5 vinnere</p>
        <p className="-my-0.5 typography-v1-h2">får en pause fra gjelden sin</p>
        <p className="mb-8 typography-v1-display">
          i <UnderlinedText>et helt</UnderlinedText> år
        </p>

        <p className="mb-4 typography-v1-body3">
          Vi overtar regningene på kredittkort og forbrukslån i 12 mnd.
          <br />
          Maks. 80 000 kr per vinner.
        </p>

        <ArrowLink
          to={routes.SUMMER_JULY_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.secondary.light,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '8px',
          flex: { md: 1 },
        }}
      >
        <p className="typography-v1-h2">Avsluttes</p>
        <p className="typography-v1-display">{dateStr}</p>
        <p className="mb-2 typography-v1-h2">om</p>
        <Timer date={SUMMER_JULY_2024_COMPETITION_END_DATE} />

        <p className="mt-6 mb-4 typography-v1-body3 md:mt-8 xl:mt-12">
          Vinnerne kontaktes via e-post og mobil. Vi tar hensyn til personvern og publiserer ikke
          vinnere uten samtykke.
        </p>

        <ArrowLink
          to={routes.SUMMER_JULY_2024_COMPETITION_TERMS}
          sx={{ display: 'block', my: 2, mt: { sm: 3 } }}
        >
          Vilkår og betingelser
        </ArrowLink>
      </Box>
    </Section>
  );
};
